import React from 'react';

const ScrollingBanner: React.FC = () => {
  const bannerText = "Limited Tickets and Tables available • Book Today";

  return (
    <div className="w-full overflow-hidden bg-transparent backdrop-blur-sm h-5 flex items-center border-t border-b border-gray-800/50">
      <style>
        {`
          @keyframes scroll-left {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-100%); }
          }
          .animate-scroll-left {
            animation: scroll-left 40s linear infinite;
          }
        `}
      </style>
      <div className="flex w-max animate-scroll-left">
        {[...Array(10)].map((_, i) => (
          <div key={i} className="flex items-center whitespace-nowrap px-8">
            <span className="text-white uppercase font-semibold text-lg tracking-widest">
              {bannerText}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollingBanner;

